export type Bonus = {
  number: string
  title: string
  description: string
  cover: string
  coverAlt: string
}

export const bonuses: Bonus[] = [
  {
    number: 'BONO 01',
    title: 'Guía Express de Configuración Perfecta para iPhone',
    description:
      'Paso a paso por los ajustes más importantes para dejar tu iPhone listo desde el primer día: pantalla, notificaciones, privacidad, batería, Face ID, iCloud y organización inicial. Una victoria rápida que notarás en los primeros 30 minutos.',
    cover: 'https://cdn.magicpatterns.com/uploads/9XTukA8FKhxV45LnbbJ6ca/bono_1.webp',
    coverAlt: 'Portada del bono Configuración Perfecta para iPhone',
  },
  {
    number: 'BONO 02',
    title: 'Checklist de Seguridad y Privacidad',
    description:
      'Punto por punto qué revisar para proteger tu información: bloqueo de pantalla, Face ID, permisos de apps, ubicación, contraseñas, copias de seguridad y protección ante pérdida o robo. Más tranquilidad en menos de una hora.',
    cover: 'https://cdn.magicpatterns.com/uploads/hjQ97BM4FSkVBoJAibzxiG/bono_2.webp',
    coverAlt: 'Portada del bono Privacidad para Proteger tu iPhone',
  },
  {
    number: 'BONO 03',
    title: 'Mini Guía de Trucos Ocultos para Ahorrar Tiempo',
    description:
      'Atajos de teclado, gestos, búsqueda ultrarrápida, escaneo de documentos, copiar texto desde fotos y comandos que casi nadie usa. Trucos que puedes probar hoy mismo en menos de 5 minutos.',
    cover: 'https://cdn.magicpatterns.com/uploads/kmFZQVST5PSmSLsw28ZRwe/bono_3.webp',
    coverAlt: 'Portada del bono Trucos Ocultos para Ahorrar Tiempo con tu iPhone',
  },
  {
    number: 'BONO 04',
    title: 'Plantilla de Organización Digital para iPhone',
    description:
      'Una estructura lista para ordenar todo: apps por categorías, pantallas limpias, fotos ordenadas, notas organizadas y una rutina simple de mantenimiento semanal. Menos caos, más orden, más control.',
    cover: 'https://cdn.magicpatterns.com/uploads/iW7f5DmRJtw8k4Z3HujHTi/bono_4.webp',
    coverAlt: 'Portada del bono Plantilla de Organización Digital para iPhone',
  },
  {
    number: 'BONO 05',
    title: 'Manual Rápido de Cámara iPhone',
    description:
      'Trucos simples de iluminación, enfoque, exposición, composición y edición básica para que tus fotos y videos se vean mucho mejor desde hoy. Resultados visibles desde la primera foto.',
    cover: 'https://cdn.magicpatterns.com/uploads/bE4zPGJNy2n34gbXF3YdpH/bono_5.webp',
    coverAlt: 'Portada del bono Manual Rápido de Cámara iPhone para fotos y videos',
  },
]
